export const AttachType = Object.freeze({
	Delimiter: 'DELIMITER',
	File: 'FILE',
	Grid: 'GRID',
	Html: 'HTML',
	Image: 'IMAGE',
	Link: 'LINK',
	Message: 'MESSAGE',
	Rich: 'RICH_LINK',
	User: 'USER'
});

export const AttachDescription = Object.freeze({
	FIRST_MESSAGE: 'FIRST_MESSAGE',
	SKIP_MESSAGE: 'SKIP_MESSAGE',
});